"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Text = _interopRequireDefault(require("../Text"));

var _overrides = require("../../../utils/overrides");

var _styles = require("../../../utils/styles");

var _styles2 = _interopRequireDefault(require("./styles"));

var useStyles = (0, _styles.createUseStyles)(_styles2.default, 'Title');

function Title(_ref) {
  var children = _ref.children,
      classesProp = _ref.classes,
      overridesProp = _ref.overrides,
      classNameProp = _ref.className,
      props = (0, _objectWithoutProperties2.default)(_ref, ["children", "classes", "overrides", "className"]);
  var classes = (0, _overrides.useClasses)(useStyles, classesProp); //Overrides

  var rootClassName = (0, _classnames.default)(classes.root, classNameProp);
  var override = (0, _overrides.getOverrides)(overridesProp, Title.overrides);
  var rootProps = (0, _extends2.default)({}, props, {
    className: rootClassName
  }, override.root);
  return /*#__PURE__*/_react.default.createElement(_Text.default, (0, _extends2.default)({
    type: "bold"
  }, rootProps), /*#__PURE__*/_react.default.createElement("h1", {
    className: classes.textTitle
  }, children));
}

Title.overrides = ['root'];
Title.defaultProps = {
  className: '',
  overrides: {}
};
process.env.NODE_ENV !== "production" ? Title.propTypes = {
  className: _propTypes.default.string,
  overrides: _propTypes.default.object,
  children: _propTypes.default.node.isRequired
} : void 0;

var _default = /*#__PURE__*/_react.default.memo(Title);

exports.default = _default;